/** @file Screen position in px (x right, y down, origin top-left) of a world point. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import { vec3Sub } from '@zilo/pose3d-math/vec3/vec3Sub';
import { projectOffset } from '@zilo/pose3d-render-core/camera/projectOffset';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';

/** `[originX, originY] + projectOffset(p - target).xy`. */
export function screenOf(p: Vec3, view: View): [number, number] {
  const s = projectOffset(vec3Sub(p, view.target), view);
  return [view.originX + s[0], view.originY + s[1]];
}
